import app from '@/app';
import templateUrl from './mensurementCount-search.html';

/* @ngInject */
function UnifilarParametersSearchController(
	$controller,
	$state,
	$http,
	DialogService,
	UnifilarParameters,
  Principal
) {
	var $ctrl = this;
	var resource = UnifilarParameters;

	$ctrl.isSearching = false;
	$ctrl.loadFailed = false;

  $ctrl.currentAccount = null;
  
  Principal.identity().then(account => {
	$ctrl.currentAccount = account;
	})

	$controller('AbstractPageSortController', { $controller, $ctrl, $state });

	var transition = $ctrl.transition;

	$ctrl.$onInit = function() {
		
   	};

	// Entering the screen only renders the filters. The survey itself is loaded by
	// the search button: querying every campaign/road up front scanned the whole
	// measurement history and never finished on large databases.
	$ctrl.transition = params => {
		transition(params);
		$ctrl.roadtype = params.roadtype;
	};

	$ctrl.onRoadTypeChange = roadtype => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
		$ctrl.campaign = null;
	};

	$ctrl.onOrganizationChange = organization => {
		$ctrl.road = null;
		$ctrl.campaigns = [];
		$ctrl.campaign = null;
	};

	$ctrl.byOrganization = value =>
		$ctrl.organization && value.organization.id == $ctrl.organization.id;

	$ctrl.byOwner = value => $ctrl.organization && value.owner.id == $ctrl.organization.id;

	$ctrl.onQueryChange = () => {
		var pCampaign = $ctrl.campaign && $ctrl.campaign.id ? $ctrl.campaign.id : null;
		var pRoad = $ctrl.road && $ctrl.road.id ? $ctrl.road.id : null;
		var pOrganization = $ctrl.organization && $ctrl.organization.id ? $ctrl.organization.id : null;

		$ctrl.isSearching = true;
		$ctrl.loadFailed = false;

		resource.query(
			{
				plantype: 'NONE',
				road: pRoad,
				roadtype: $ctrl.roadtype,
				campaign: pCampaign,
				organization: pOrganization,
				sort: $ctrl.sort,
				page: 0,
				size: $ctrl.size
			},
			data => {
				$ctrl.entities = data.content;
				$ctrl.count = data.totalElements;
				$ctrl.isSearching = false;
			},
			// Without this the screen stayed blank on timeout, with no clue for the user
			() => {
				$ctrl.entities = [];
				$ctrl.count = 0;
				$ctrl.loadFailed = true;
				$ctrl.isSearching = false;
			}
		);
	};

	$ctrl.remove = (id, name) => resource.remove({ id: id }, () => $state.reload()).$promise;
}

app.component('mensurementCountSearch', {
	templateUrl,
	controller: UnifilarParametersSearchController,
	bindings: {
		$transition$: '<',
		allOrganizations: '<',
		allRoads: '<',
		allCampaigns: '<',
		allDecisionTrees: '<',
		allCriteriaSets: '<'
	}
});
